module.exports = __webpack_public_path__ + "static/media/wil-angliss.7e3197c7.jpg";